/**
 * The Kaya mark — the app icon itself, not a redrawing of it.
 *
 * It lives in one component because it was previously inlined as SVG in both the shell header and
 * the login screen, and the two silently kept the old ring-and-check for a release after the icon
 * was replaced. Pointing at the same PNG the manifest ships means the header can never disagree
 * with the home-screen icon again.
 *
 * 192px source for a 34px box, so it stays sharp on a 3x phone screen.
 */
export function Mark() {
  return <img src="/icons/icon-192.png" alt="" width={192} height={192} decoding="async" />;
}
